// web-staking-estimator-frontend/src/components/forms/ServiceLocationForm.js
import React from "react";

export default function ServiceLocationForm({ member, onMemberChange, defaultState = "OR" }) {
  const stateDefault = defaultState || "OR";
  return (
    <div>
      <h4 className="aoi-label">Approximate location of new service:</h4>

      <div className="formRow">
        <label className="label" htmlFor="street">Street</label>
        <input
          id="street"
          className="input"
          value={(member?.street) || ""}
          onChange={(e) => onMemberChange?.({ ...(member || {}), street: e.target.value })}
        />
      </div>

      <div className="formRow">
        <label className="label" htmlFor="city">City</label>
        <input
          id="city"
          className="input"
          value={(member?.city) || ""}
          onChange={(e) => onMemberChange?.({ ...(member || {}), city: e.target.value })}
        />
      </div>

      <div className="formRow">
        <label className="label" htmlFor="state">State</label>
        <select
          id="state"
          className="input"
          value={(member?.state || stateDefault)}
          onChange={(e) => onMemberChange?.({ ...(member || {}), state: (e.target.value || stateDefault).toUpperCase() })}
        >
          {["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"].map(s =>
            <option key={s} value={s}>{s}</option>
          )}
        </select>
      </div>
      
      <div className="formRow">
        <label className="label" htmlFor="zip">ZIP</label>
        <input
          id="zip"
          className="input"
          value={(member?.zip) || ""}
          onChange={(e) => onMemberChange?.({ ...(member || {}), zip: e.target.value })}
        />
      </div>
    </div>
  );
}
